<template>
    <v-app>
    
        <Alert /> 

        <div class="app"> 

            <SideMenu /> 

            <Header />
        
            <v-main class="content">        
                <div class="cardContent">
                    <v-card class="cardItem">
                        <form>

                            <v-row>
                                <v-col cols="12" md="12">
                                    <h3>Editar Personalizado</h3>
                                </v-col>
                            </v-row>  

                            <v-row>
                                <v-col cols="12" md="3">
                                    <v-select
                                        :items="['Ativo', 'Inativo']"
                                        v-model="status"
                                        label="Status"
                                        required
                                        solo
                                        light
                                    ></v-select>
                                </v-col>                                
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="12">
                                    <v-select
                                        :items="listaEmpresa"
                                        v-model="empresaSelecionada"
                                        label="Empresa"
                                        item-text="nome"
                                        item-value="_id"
                                        required
                                        solo
                                        light
                                    ></v-select>
                                </v-col>
                            </v-row>                          

                            <v-row>
                                <v-col cols="12" md="10">
                                    <v-select
                                        :items="listaEquipamentos"
                                        v-model="equipamento"
                                        label="Local Equipamento"
                                        item-text="nome"
                                        item-value="_id"
                                        required
                                        solo
                                        light
                                    ></v-select>
                                </v-col>
                                <v-col cols="12" md="2" style="padding-top: 20px;">
                                    <v-btn
                                        small                                            
                                        color="#ea6936" 
                                        dark 
                                        v-on:click="modalLocal"
                                    >
                                        Novo Local
                                    </v-btn>
                                </v-col>
                            </v-row>

                            <v-row>                                
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="nome"
                                        label="Nome"
                                        required
                                        solo
                                        light
                                    ></v-text-field>
                                </v-col>  
                            </v-row>   

                            <v-row>                                
                                <v-col cols="12">
                                    <v-textarea
                                        solo
                                        light
                                        v-model="descricao"
                                        label="Descrição"
                                    ></v-textarea>
                                </v-col>
                            </v-row>

                            <v-row>    
                                <v-col cols="12" md="9">
                                    <v-text-field
                                        v-model="identificacao"
                                        label="Identificação"
                                        required
                                        solo
                                        light
                                    ></v-text-field>
                                </v-col>  
                                <v-col cols="12" md="3">
                                    <v-text-field
                                        v-model="validade"
                                        label="Validade"
                                        required
                                        solo
                                        light
                                    ></v-text-field>
                                </v-col>                                                                              
                            </v-row>   
                           
                            <v-row>       
                                <v-col cols="12" md="4">
                                    <v-select
                                        :items="listaModelos"
                                        v-model="modelo"
                                        label="Modelo"
                                        item-text="nome"
                                        item-value="_id"
                                        required
                                        solo
                                        light
                                    ></v-select>
                                </v-col>      
                                <v-col cols="12" md="4">
                                    <v-select
                                        :items="[
                                            'Mensal', 
                                            'Bimestral', 
                                            'Trimestral', 
                                            'Semestral', 
                                            'Anual'
                                        ]"
                                        v-model="periodo"
                                        label="Periodo da Inspeção"
                                        item-text="value"
                                        item-value="id"
                                        required
                                        solo
                                        light
                                    ></v-select>
                                </v-col>                           
                                <v-col cols="12" md="4">
                                    <v-select
                                        :items="[
                                            'Ativo', 
                                            'Vencido', 
                                            'Manutenção', 
                                            'Inativo', 
                                            'Condenado'
                                        ]"
                                        v-model="situacao"
                                        label="Situação"
                                        required
                                        solo
                                        light
                                    ></v-select>
                                </v-col>                                    
                            </v-row>
                           
                            <v-row class="rowButton">
                                <v-col cols="12" md="12">
                                    <v-btn
                                        small                                            
                                        color="#ea6936" 
                                        dark 
                                        v-on:click="salvarDados"
                                    >
                                        Salvar Dados
                                    </v-btn>
                                </v-col>
                            </v-row>

                        </form>
                    </v-card>
                </div>
            </v-main>

            <v-dialog v-model="dialog" width="500px">            
                <v-card>
                    <v-card-title>
                        <span class="text-h5">Local de Equipamento</span>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    v-model="nomeLocal"
                                    label="Nome"
                                    required
                                    solo
                                    light
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#ea6936"
                            text
                            @click="dialog = false"
                        >
                            Fechar
                        </v-btn>
                        <v-btn
                            color="#ea6936"
                            text
                            @click="salvarLocal"
                        >
                            Salvar
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            
        </div>   
    
    </v-app>
</template>

<script>
    import Alert from '@/_components/shared/Alert';
    import Header from '@/_components/Header';
    import SideMenu from '@/_components/SideMenu';
    import http from '@/_services/http';
    import store from "@/_store";

    export default {
        components: {
            Alert,
            Header,
            SideMenu
        },
        data () {
            return {   
                id: "",
                dialog: false,
                nomeLocal: "",
                listaEmpresa: [],
                listaEquipamentos: [],
                listaModelos: [],
                empresaSelecionada: "",
                equipamento: "",
                nome: "",
                descricao: "",
                identificacao: "",
                validade: "",
                modelo: "",
                periodo: "",
                situacao: "",
                status: ""
            }
        },
        created () {
            this.initialize();
        },
        methods: {
            initialize () {
               let id = window.location.pathname;
                id = id.split("/");
                id = id[3];
                let url = "custom-item/get/" + id;
                this.id = id;
                http.get(url)
                    .then((response) => {
                        this.setarDados(response.data.Response);
                    })
                    .catch((error) => {
                        console.log(error);
                        store.dispatch("Notification/alert", {
                            type: "error",
                            message: "Ocorreu um erro",
                            timeClose: 3000
                        });
                    });          
            },

            setarDados(dados){
                this.id = dados._id;
                this.empresaSelecionada = dados.empresa;
                this.equipamento = dados.local;
                this.nome = dados.nome;
                this.descricao = dados.descricao;
                this.identificacao = dados.identificacao;
                this.validade = dados.validade;
                this.modelo = dados.tipo;
                this.periodo = dados.periodicidade_inspecao;
                this.situacao = dados.status;      
                if(dados.ativo){
                    this.status = "Ativo";
                } else {
                    this.status = "Inativo";
                } 
                this.buscarLocal();
            },

            buscarLocal(){
                http.get("locals/getAll")
                    .then((response) => {
                        this.listaEquipamentos = response.data.Response;
                        this.buscarEmpresa();
                    })
                    .catch((error) => {
                        console.log(error);
                        store.dispatch("Notification/alert", {
                            type: "error",
                            message: "Ocorreu um erro",
                            timeClose: 3000
                        });
                    });
            },

            buscarEmpresa(){
                http.get("companies/getAll")
                    .then((response) => {
                        this.listaEmpresa = response.data.Response.filter(item => {
                            return item.ativo == true;
                        });
                        this.buscarModelos();
                    })
                    .catch((error) => {
                        console.log(error);
                        store.dispatch("Notification/alert", {
                            type: "error",
                            message: "Ocorreu um erro",
                            timeClose: 3000
                        });
                    });
            },

            buscarModelos(){
                http.get("types/getAll")
                    .then((response) => {
                        this.listaModelos = response.data.Response.filter(item => {
                            if(item.ativo == true && item.nome !== "EXTINTOR" && item.nome !== "HIDRANTE"){
                                return true;
                            }
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                        store.dispatch("Notification/alert", {
                            type: "error",
                            message: "Ocorreu um erro",
                            timeClose: 3000
                        });
                    });
            },

            salvarDados(){
                let flagAtivo = false;
                if(this.status === "Ativo"){
                    flagAtivo = true;
                }
                let objEnvio = {
                    "id": this.id,
                    "empresa": this.empresaSelecionada,
                    "local": this.equipamento,
                    "nome": this.nome,
                    "descricao": this.descricao,
                    "identificacao": this.identificacao,
                    "validade": this.validade,
                    "tipo": this.modelo,
                    "periodicidade_inspecao": this.periodo,
                    "status": this.situacao,
                    "ativo": flagAtivo
                }
                let url = "custom-item/edit/" + this.id;
                http.post(url, objEnvio).then((response) => {
                    if(!response.data.status) {
                        store.dispatch("Notification/alert", {
                            type: "warning",
                            message: response.data.message,
                            timeClose: 3000
                        });
                    } else {                            
                        store.dispatch("Notification/alert", {
                            type: "info",
                            message: "Dados editados com sucesso",
                            timeClose: 3000
                        });       
                        setTimeout(function(){
                            window.location.href = "/personalizados";  
                        }, 2000);                              
                    }
                }).catch((error) => {
                    console.log(error);
                    store.dispatch("Notification/alert", {
                        type: "error",
                        message: "Ocorreu um erro",
                        timeClose: 3000
                    });
                });                
            },

            salvarLocal(){
                let objEnvio = {
                    "nome": this.nomeLocal,
                    "modelo": "Personalizada",
                    "descricao": "-"
                };
                http.post("locals/add", objEnvio).then((response) => {
                    if(!response.data.status) {
                        store.dispatch("Notification/alert", {
                            type: "warning",
                            message: response.data.message,
                            timeClose: 3000
                        });
                    } else {           
                        store.dispatch("Notification/alert", {
                            type: "info",
                            message: "Dados salvos com sucesso",
                            timeClose: 3000
                        });   
                        setTimeout(function(){
                            window.location.href = "/personalizado/novo";
                        }, 2000);                                            
                    }
                }).catch((error) => {
                    console.log(error);
                    store.dispatch("Notification/alert", {
                        type: "error",
                        message: "Ocorreu um erro",
                        timeClose: 3000
                    });
                });
            },

            modalLocal(){
                this.dialog = true;
            },
        }
  }  
</script>

<style scoped lang="scss">  
    .cardContent {
        display: flex;
        justify-content: center;
    }
    .cardItem {
        float: left;
        display: block;
        height: 100%;
    }
</style>